<template lang="html">
<!-- -->
</template>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'sso',
  methods: {
    ...mapActions([
      'setSpinnerStatus',
      'login_success',
      'login_error',
      'setMenuList',
      'setLabelGroupList',
      'setFullModelList',
      'setLanguageList',
      'setCurLanguage'
    ]),
    loadMenuList () {
      if (this.getCurUser.ccadmEnabled) {
        this.axios
        .get('/ccb/auth/fe/menu/menulist' ,  {
          params:{modelName: this.getCurModel, language:this.getCurLanguage},
          ...this.authHeader}
            
            )
            .then((response) => {
              this.setMenuList(response.data);      
              localStorage.setItem('menuList', JSON.stringify(response.data));
              var scope = this
              setTimeout(() => {
                scope.initLabelGroupList()
                document.querySelector('#sidebar .nav li span').click();
                document.querySelector('#sidebar .nav li div ul li a').click()
              }, 200);
            });
      }
      else {
        this.setMenuList({});      
        localStorage.setItem('menuList', JSON.stringify({}));
      }
    },
    initLabelGroupList(){      
      var menSrc = this.getMenuList
      if (menSrc && menSrc.submenuList) this.setLabelGroupList(menSrc.submenuList);
    },
    loadFullModelsByCountry(country){
      //console.log(country)
      this.axios
      .get('/ccb/public/api/countryModel/getModelListJsonByCountry' ,  {
        params:{country:country},
        ...this.authHeader}
          
          )
          .then((response) => {
            this.setFullModelList(response.data)
          });
    },
    loadLanguages () {
       this.axios
      .get('/ccb/auth/fe/language/langlist' ,  {
        params:null,
        ...this.authHeader}
          
          )
          .then((response) => {
            localStorage.setItem('langList', JSON.stringify(response.data));
            this.setLanguageList(response.data);
          });
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'authHeader',
      'getCurModel',
      'getMenuList',
      'getCurUser'
    ])
  },
  watch: {
  },
  created() {
    this.setSpinnerStatus(true);
    this.axios
      .post('/ccb/public/ssoLogin', {},{params: {username:this.$route.query.user, token:this.$route.query.token}})
        .then(response => {
          //console.log("Response: '" + response.data + "' with Statuscode " + response.status);
          if(response.status == 200) {
            //console.log("Login successful");
            // place the loginSuccess state into our vuex store
            this.login_success(response.data);
            //console.log(response.data.user.countries[0].id)
            this.$nextTick(() => {
              if (this.getCurUser.lang) {
                this.setCurLanguage(this.getCurUser.lang);
              }
              else {
                this.setCurLanguage("en");
              }
              this.setFullModelList(response.data.user.ccadmFullModelList)
              this.loadLanguages();
              this.loadMenuList();
              this.$router.push("/");
              this.setSpinnerStatus(true);
            })
          }
        })
        .catch(error => {
          this.setSpinnerStatus(false);
          // place the loginError state into our vuex store
          this.login_error({
            username: this.$route.query.user
          });
          this.$router.push("/");
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        })
  },
  mounted() {
  }
}
</script>